import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, apiKey, 'customer-number'] as const
// stored on location from legacy, but never changes per location
// once cred details are migrated over - customer-number can be removed from location fields
const locationCredentialTypes = ['customer-number'] as const

export type ctiiCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]
export const ctiiDocumentTypes = [
  'attempted-delivery',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const ctii: CarrierDef<ctiiCredType> = {
  name: 'Central Transport',
  scac: 'ctii',
  credentialTypes,
  locationCredentialTypes,
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  legacyCredMap: [
    ...userPassMap,
    ['customer-number', 'ref1'],
    ['api-key', 'apiKey'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'tracking',
    'documents',
  ],
  documentTypes: ctiiDocumentTypes,
  credentialConfig: {
    'customer-number': { customerIdentifier: true },
  },
}
